module.exports = __webpack_public_path__ + "img/ProfilePic6.ffe9b348.png";